import { Flex, Stack } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { AIDetectionFeature } from "./ai-detection-feature";

export const FlexFeatures = () => {
    const { t } = useTranslation(["common"]);

    return (
        <Stack spacing={"0rem"} mt={"0.5rem"}>
            <AIDetectionFeature />
            {/* <Flex align={"center"} gap={"0.25rem"}>
                <IconCheck size={16} />
                <p style={{fontSize: "14px"}}>{t("upgrade.flex.plagiarism-detection")}</p>
            </Flex> */}
            <Flex align={"flex-start"} gap={"0.25rem"}>
                <IconCheck size={16} style={{ marginTop: "8px" }} />
                <p style={{fontSize: "14px"}}>{t("upgrade.flex.follow-up-questions")}</p>
            </Flex>

        </Stack>
    );
};
